export default {"src":"/_next/static/media/bitget-wallet.cfc484ad.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};